export const getExperimentVariant = ({ assignments = {} } = {}) => (key) => {
  return Object.hasOwn(assignments, key) ? assignments[key] : null;
};

export const isInExperiment = ({ assignments = {} } = {}) => (key) => {
  return Object.hasOwn(assignments, key);
};

// 0 = control or not assigned, 1+ = treatment variants
export const getVariationIndex = ({ assignments = {} } = {}) => (key) => {
  return Object.hasOwn(assignments, key)
    ? Number(assignments[key]?.variationIndex) || 0
    : 0;
};

export const getPageViewEventId = ({ pageViewEventId }) => pageViewEventId;
